import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IActiveItem } from '../models/modules';
import { IMaterial } from '../../../core/models/disciplines';

interface MaterialState {
  materials: IMaterial[];
  material: any;
  nextLink: any;
  previousLink: any;
  currentMaterialIndex: number;
  allMaterials: any;
  active: IActiveItem | null; //Assunto ativo
  isLoading: boolean;
  _hasHydrated: boolean | null;
  setActive: (subject: IActiveItem | null) => void;
  setMaterials: (material: IMaterial[]) => void;
  setMaterial: (slug: any) => void;
  setFavorite: () => void;
  setReview: (review: 'like' | 'dislike' | undefined) => void;
  setIsLoading: (loading: boolean) => void;
  setHasHydrated: (hydrate: boolean) => void;
  setNextAndPreviousMaterial: (baseLink: string) => void;
  setAllMaterials: (material: IMaterial[]) => void;
  resetMaterial: () => void;
}

export const useMaterialStore = create<MaterialState>()(
  persist(
    (set, get) => ({
      material: null,
      materials: [],
      nextLink: null,
      previousLink: null,
      allMaterials: [],
      active: null,
      isLoading: false,
      _hasHydrated: false,
      currentMaterialIndex: 0,
      setActive: (subject: IActiveItem | null) => set({ active: subject }),
      setMaterials: (material: IMaterial[]) => set({ materials: material, allMaterials: material }),
      setAllMaterials: (material: IMaterial[]) => set({ allMaterials: material }),
      setMaterial: async (slug) => {
        const allMaterials = get().allMaterials;
        const materialData = allMaterials.find((wb: { slug: any; }) => wb.slug === slug);
        const currentMaterialIndex = allMaterials.findIndex((wb: { slug: any; }) => wb.slug === slug);

        set({
          material: materialData,
          currentMaterialIndex: currentMaterialIndex,
        });
      },
      setNextAndPreviousMaterial: (baseLink: string) => {
        const currentMaterialIndex = get().currentMaterialIndex;
        const allMaterials = get().allMaterials;

        if (currentMaterialIndex !== -1 && currentMaterialIndex < allMaterials.length - 1) {
          const nextIndex = currentMaterialIndex + 1;
          const nextLink = `${baseLink}/${allMaterials[nextIndex]?.slug}`;
          set({ nextLink });
        }

        if (currentMaterialIndex && currentMaterialIndex > 0) {
          const previousIndex = currentMaterialIndex - 1;
          const previousLink = `${baseLink}/${allMaterials[previousIndex]?.slug}`;
          set({ previousLink });
        }
      },
      setIsLoading: (loading: boolean) => set({ isLoading: loading }),
      setHasHydrated: (hydrate: boolean) => set({ _hasHydrated: hydrate }),
      setReview: (review: 'like' | 'dislike' | undefined) => {
        const material = get().material;
        const slug = material.slug;

        const allMaterials = (get().allMaterials || []).map((it: { slug: any; }) => {
          if (it.slug === slug) {
            return {
              ...it,
              review: review,
            };
          }
          return it;
        });

        const newMaterial = { ...material, review: review };
        const newAllMaterials = allMaterials;

        set({
          material: newMaterial,
          allMaterials: newAllMaterials,
        });

      },
      setFavorite: () => {
        const material = get().material;
        const slug = material.slug;

        const allMaterials = (get().allMaterials || []).map((it: { slug: any; }) => {
          if (it.slug === slug) {
            return {
              ...it,
              favorite: !material.favorite,
            };
          }
          return it;
        });

        const newMaterial = { ...material, favorite: !material.favorite };
        const newAllMaterials = allMaterials;

        set({
          material: newMaterial,
          allMaterials: newAllMaterials,
        });

      },
      resetMaterial: () => set({ 
        material: null,
        materials: [],
        nextLink: null,
        previousLink: null,
        allMaterials: [],
        active: null,
        isLoading: false,
        _hasHydrated: false,
        currentMaterialIndex: 0,
      })
    }),
    {
      name: 'discipline-material',
      onRehydrateStorage: () => (state) => {
        state && state.setHasHydrated(true);
      },
    },
  ),
);
